import React from "react";
import { UserBubble } from "./chatBubbles";

function CustomUserMessage ({title, message}: any) {
  return (
    <UserBubble>
      <div className="message-title">{title}</div>
      <div className="message-text">{message}</div>
    </UserBubble>
  )
}
  
export default CustomUserMessage;
/* <div className="w-3 bg-[#EBEBEB]">
<div className="bg-[#F5F5F5] w-3 h-full rounded-bl-[10px]" />
</div> */
